import * as React from 'react';

import styled from 'styled-components';

import Flex from '@components/layout/flex';

interface MerchCardProps {
  className?: string;
  children: React.ReactNode;
}

export const MerchCard: React.FC<MerchCardProps> = ({
  className,
  children,
}) => {
  return (
    <MerchCardContainer className={className}>{children}</MerchCardContainer>
  );
};

export default MerchCard;

const MerchCardContainer = styled(Flex).attrs(() => ({
  justifyContent: 'center',
  alignItems: 'center',
  flexDirection: 'row',
  flexShrink: '0',
}))`
  user-select: none;
  position: relative;
  height: 350px;
`;
